import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrUnlockedIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M5.70078 4.9998C5.70078 3.72955 6.73053 2.6998 8.00078 2.6998C8.6819 2.6998 9.29315 2.99498 9.71529 3.46664C9.97312 3.75471 10.4157 3.77923 10.7037 3.5214C10.9918 3.26357 11.0163 2.82103 10.7585 2.53296C10.082 1.77713 9.09666 1.2998 8.00078 1.2998C5.95733 1.2998 4.30078 2.95635 4.30078 4.9998V5.2998H3.00078C2.0619 5.2998 1.30078 6.06092 1.30078 6.9998V12.9998C1.30078 13.9387 2.0619 14.6998 3.00078 14.6998H13.0008C13.9397 14.6998 14.7008 13.9387 14.7008 12.9998V6.9998C14.7008 6.06092 13.9397 5.2998 13.0008 5.2998H5.70078V4.9998ZM3.00078 6.6998H13.0008C13.1665 6.6998 13.3008 6.83412 13.3008 6.9998V12.9998C13.3008 13.1655 13.1665 13.2998 13.0008 13.2998H3.00078C2.8351 13.2998 2.70078 13.1655 2.70078 12.9998V6.9998C2.70078 6.83412 2.8351 6.6998 3.00078 6.6998Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrUnlockedIconComponent;
